import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  middle: {
    width: '25px'
  }
}));

export default useStyles;